import getConfig from 'next/config';

export const isProduction = (): boolean => {
  const { environment } = getConfig().publicRuntimeConfig;
  return environment === 'production';
};
